import { useNavigate } from 'react-router-dom'
import StatusBadge from '../../UI/statusBadge'
import ProductImage from './productImage'
import { formatPrice } from '../../../utils/formatPrice'

const ProductMainCard = ({product ,id}) => {
  const navigate = useNavigate()
  console.log('currency_factor', product?.price)
  const price =formatPrice(  product?.currency_factor,product?.price)  
  return (
    <section className="card rounded-3">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="font16">المعلومات الأساسية</h4>
              <button className="btn btn-primary" type='button' onClick={()=>navigate(`${process.env.PUBLIC_URL}/product/edit/${id}`)}>تعديل المعلومات</button>
            </div>
            <h4 className="font16">صورة المنتج </h4>

          
            <ProductImage src={product?.images && product?.images[0]?.image_path} product={product}/>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                 <div className="mt-3 d-flex align-items-center gap-3">
              <h4 className="font700 font16"> {product.name}</h4>
                  <div className="rounded-3 bg-neutral-100 p-2 font700">
                    {product?.category?.name}
                  </div>
              <StatusBadge status={product?.is_active ?"active":"inActive"} />
            </div>
            <p className="desc text-start">{product?.description}</p>
              </div>
               <div>
                <h5>
                  السعر الأساسي
                </h5>
                <h4 className="text-green ">{price} {product?.symbol_currency}</h4>
               </div>
                

            
            </div>
            <div className="d-flex justify-content-between align-items-center">
                    <div className="font16"> الكمية: <span className="font700">{product?.quantity}قطعة</span>   </div>
                    <div className="font16"> وقت التحضير المتوقع: <span className="font700">{product?.preparation_time_unit}{product?.preparation_time}</span></div>
            </div>
        
          </div>   
        </section>
  )
}

export default ProductMainCard